import React from "react";
import styled from "styled-components";
import { translations } from "../../../utils/translations";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import {
  getAccountDetails,
  getAccountOrders,
} from "../../../services/authService";
import { useAuth } from "../../../hooks/useAuth";
import { getUserIdFromToken } from "../../../utils/utils.ts";
import AccountOrders from "../../components/AccountOrders.tsx";

const Wrapper = styled.div`
  background-color: rgba(241, 239, 237, 0.34);
  backround-opacity: 0.5;
  width: 100%;
  height: 100%;
`;

const Title = styled.p`
  width: 100%;
  border-bottom: 2px solid var(--background-yellow);
  font-size: 25px;
  padding: 16px 32px;
  font-family: Georgia, serif;
  color: var(--secondary-font-color);
  margin: 0;
`;
const DetailsSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: space-between;
  width: 100%;
`;
const DetailsWrapper = styled.div`
  padding: 16px 32px;
  background-color: white;
  margin: 8px 16px;
  border-radius: 8px;
  flex: 1;
  height: 100%;

  p {
    font-size: 14px;
    margin: 0;
    padding: 4px 0;
    font-family: Georgia, serif;
    color: var(--secondary-font-color);
  }
`;
const SubsectionTitle = styled.p`
  border-bottom: 2px solid var(--background-yellow);
  font-size: 18px;
  padding: 16px 32px;
  font-family: Georgia, serif;
  color: var(--secondary-font-color);
  margin: 0;
`;

const Account = () => {
  const languageCode = useSelector((state) => state.settings.languageCode);
  const { token } = useAuth();
  const userId = getUserIdFromToken(token);
  const { data: accountDetails } = useQuery({
    queryKey: ["accountDetails"],
    queryFn: () => getAccountDetails(userId),
    retry: false,
  });

  const { data: orders } = useQuery({
    queryKey: ["orders"],
    queryFn: () => getAccountOrders(userId),
    enabled: !!accountDetails?.email,
    retry: false,
  });
  return (
    <Wrapper>
      <Title>{translations[languageCode]["account-title"]}</Title>
      {accountDetails ? (
        <DetailsSection>
          <DetailsWrapper>
            <SubsectionTitle>
              {translations[languageCode]["account-details-title"]}
            </SubsectionTitle>
            <p style={{ fontSize: "18px" }}>
              {accountDetails?.firstName} {accountDetails?.lastName}
            </p>
            <p>{accountDetails?.email}</p>
            <p>{accountDetails?.phoneNumber}</p>
          </DetailsWrapper>
          <DetailsWrapper>
            <SubsectionTitle>
              {translations[languageCode]["account-address-title"]}
            </SubsectionTitle>
            {accountDetails?.address &&
            accountDetails?.address?.city !== "Unknown" ? (
              <div>
                <p>
                  {accountDetails?.address?.city}
                  {", "}
                  {accountDetails?.address?.county}, Romania
                </p>
                <p>{accountDetails?.address?.street}</p>
              </div>
            ) : (
              <p style={{ paddingTop: "8px", color: "gray" }}>
                {translations[languageCode]["account-no-address"]}
              </p>
            )}
          </DetailsWrapper>
        </DetailsSection>
      ) : (
        <DetailsSection>
          <p style={{ padding: "8px 16px" }}>
            {translations[languageCode]["account-no-data"]}
          </p>
        </DetailsSection>
      )}
      <AccountOrders
        orders={orders}
        account={{
          email: accountDetails?.email,
          phoneNumber: accountDetails?.phoneNumber,
        }}
      />
    </Wrapper>
  );
};

export default Account;
